<div id="sports" class="inner-page py-5">
  <div class="container px-lg-5">

    <!-- Header Section -->
    <div class="text-center mb-5">
      <h1 class="display-6 fw-bold text-uppercase text-orange mb-2" style="color: #f48020;">Welcome to Our Sports Department</h1>
      <h4 class="fw-semibold text-dark mb-4">"Where Dreams Become Victories"</h4>
      <p class="lead text-muted mx-auto" style="max-width: 900px; line-height: 1.8; text-align: justify;">
        Our Sports Department is a beacon of excellence and dedication, fostering young talent to achieve remarkable feats at various levels of competition. We pride ourselves on our state-of-the-art facilities and robust training program, consistently producing exceptional athletes. Here’s a glimpse into what makes our sports program stand out:
      </p>
      <hr class="divider mx-auto" style="width: 80px; height: 3px; background: var(--primary); border: none; opacity: 1;">
    </div>

    <!-- Content Sections -->
    <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success mb-5">
      
      <!-- State-of-the-Art Facilities -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">State-of-the-Art Facilities</h5>
      <p class="text-muted mb-3">We are equipped with world-class facilities, catering to a wide range of sports. Our infrastructure includes:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Khel Gaon:</strong> A comprehensive sports village with amenities for various sports.</li>
        <li class="mb-2"><strong>Dedicated Grounds:</strong> For kho-kho, kabaddi, athletics, cricket, judo, basketball, and more.</li>
        <li class="mb-2"><strong>Training Halls and Gyms:</strong> Equipped with the latest equipment to ensure our athletes have everything they need to excel.</li>
        <li class="mb-2"><strong>Indoor and Outdoor Courts:</strong> To facilitate year-round training regardless of weather conditions.</li>
      </ul>

      <!-- Annual Sports Camp -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Annual Sports Camp</h5>
      <p class="text-muted mb-3">Every year, we organize a one-month sports camp aimed at honing the skills of our young athletes. During this camp, we offer:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Expert Coaching:</strong> Our coaches are seasoned professionals dedicated to bringing out the best in each player.</li>
        <li class="mb-2"><strong>Intensive Training:</strong> Focused sessions that cover techniques, fitness, strategy, and mental conditioning.</li>
        <li class="mb-2"><strong>Skill Enhancement:</strong> Tailored programs to improve individual and team performance.</li>
      </ul>

      <!-- Achievements -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Achievements</h5>
      <p class="text-muted mb-3">Our players have consistently brought home medals and accolades, proving their mettle at various levels:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>International and National Champions:</strong> Our athletes have represented the country and brought home numerous medals.</li>
        <li class="mb-2"><strong>All India and State Level Victories:</strong> We have a strong presence in the state and national championships across multiple sports.</li>
        <li class="mb-2"><strong>Inter-University Competitions:</strong> Our university teams have excelled, consistently winning top honours.</li>
      </ul>

      <!-- Notable Mentions -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Notable Mentions</h5>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Cricket:</strong> Our cricket team has won several national tournaments.</li>
        <li class="mb-2"><strong>Kho Kho and Kabaddi:</strong> Dominating performances in state and national championships.</li>
        <li class="mb-2"><strong>Athletics:</strong> Our athletes have set records and brought laurels in track and field events.</li>
        <li class="mb-2"><strong>Judo and Basketball:</strong> Achievements at the international level, showcasing our prowess.</li>
        <li class="mb-2"><strong>Skating:</strong> Our skaters have bagged many medals in national and international championships.</li>
      </ul>

      <!-- Our Mission -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Our Mission</h5>
      <p class="text-muted mb-3" style="text-align: justify; line-height: 1.8;">
        We aim to nurture talent, and discipline, and promote sportsmanship. By providing top-notch facilities and expert coaching, we ensure our athletes are well-prepared to compete at the highest levels and achieve their dreams.
      </p>
      <p class="text-muted mb-0" style="text-align: justify; line-height: 1.8;">
        Under the leadership of <strong>Dr Rishu Tomar</strong>, our Sports in charge, and the dedicated services of <strong>Ms Naresh, Ms Raman Sethi, and Anita</strong> from the Physical Education Department, our program continues to thrive and set new benchmarks in the realm of sports.
      </p>

      <!-- Celebrating Sportsmanship Alert Banner -->
      <div class="p-4 rounded-4 mt-5 text-center" style="background-color: #fcece3; border: 1px solid #ffd8c3;">
        <h5 class="fw-bold mb-2" style="color: #e06c00;">Join us in celebrating the spirit of sportsmanship and excellence.</h5>
        <p class="mb-0 fw-semibold text-muted" style="font-size: 15px;">Explore our programs, meet our champions, and be a part of our journey towards greatness.</p>
      </div>

    </div>

    <!-- Photo Gallery Grid -->
    <div class="mb-4">
      <h3 class="fw-bold text-dark text-uppercase mb-3 text-center">Photo Gallery</h3>
      <hr class="divider mx-auto mb-4" style="width: 60px; height: 3px; background: var(--primary); border: none; opacity: 1;">
      
      <div class="row g-3 justify-content-center">
        <div class="col-6 col-sm-4 col-md-3" *ngFor="let img of sportsImages">
          <div class="rounded-4 overflow-hidden shadow-sm border border-2 border-white position-relative gallery-item">
            <img [src]="img" alt="Sports Activity" class="img-fluid w-100" style="object-fit: cover; height: 180px; transition: transform 0.3s ease;">
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
